
import { Badge } from "@/components/ui/badge";

interface HabitCardCategoriesProps {
  categories: string[];
  onClick?: (category: string) => void;
}

export const HabitCardCategories = ({ categories, onClick }: HabitCardCategoriesProps) => {
  const handleCategoryClick = (category: string) => {
    if (onClick) {
      onClick(category);
    } else {
      const categoryEvent = new CustomEvent('category-selected', {
        detail: { category }
      });
      window.dispatchEvent(categoryEvent);
    }
  };

  return (
    <div className="flex flex-wrap gap-1">
      {categories.map((category, index) => (
        <Badge
          key={index}
          className="bg-primary text-white text-xs cursor-pointer hover:bg-primary/80 transition-colors"
          variant="secondary"
          onClick={(e) => {
            e.stopPropagation();
            handleCategoryClick(category);
          }}
        >
          {category}
        </Badge>
      ))}
    </div>
  );
};
